import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {AxisLabelsFormatterContextObject, Options} from "highcharts";

export class Raw extends AbstractChart {
    protected allChartOptions(): Options {
        const yAxisLabels = $(this.target).data('y-axis-labels');
        const options: Options = {
            chart: {
                type: 'bar',
                marginLeft: 20,
                marginTop: 10,
                spacingBottom: 24,
                spacingTop: 11,
                width: 320
            },
            plotOptions: {
                bar: {
                    maxPointWidth: 11,
                    borderWidth: 0
                }
            },
            xAxis: {
                labels: {
                    // xAxis is labelled separately outside the chart
                    enabled: false,
                }
            },
            yAxis: {
                tickPositions: [0, 1, 2],
                labels: {
                    style: {
                        fontSize: '6pt',
                        fontWeight: '400',
                        fontColor: 'black'
                    },
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        return yAxisLabels !== undefined ? yAxisLabels[this.value] : this.value;
                    }
                },
                title: {
                    useHTML: true,
                    text: null,
                    style: {
                        fontSize: '8.5pt',
                        fontWeight: '400',
                        color: 'black'
                    }
                }
            },
            colors: [
                '#497b95'
            ]
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {registerPlugin(Raw)}